import { useConfirm } from "material-ui-confirm";
import { useEffect, useState } from "react";
import { useAppContext } from "../../context/AuthContext";
import { TicketController, TicketControllerType } from "../../controller/ticket/TicketCotroller";
import Labels from "../../lang/Labels_en";
import TicketDto from "../../model/ticket/TicketDto";
import EnumTicketStatus from "../../utils/enum/EnumTicketStatus";
import EnumTicketType from "../../utils/enum/EnumTicketType";
import { handleErrorMessage } from "../../utils/Utils";
interface TicketsServiceType {
  openModal: any;
  closeModal: any;
  ticketList: any;
  ticketSave: any;
  getTicketList: any;
  ticketDelete: any;
  getTicketByID: any;
  ticket: any;
  sendTicketResponse: any;
  getTicketReviewList: any;
  ticketAwaitReviewList: any;
  ticketOpenReviewList: any;
  ticketClosedReviewList: any;
  enumTicketTypeList: any;
  open: any;
  setOpen: any;
  expanded: any;
  handleChange: Function;
}

export default function TicketsService(): TicketsServiceType {
  const { showMessage } = useAppContext();
  const [open, setOpen] = useState<any>(false);
  const [ticketList, setTicketList] = useState<Array<TicketDto>>([]);
  const [ticketAwaitReviewList, setTicketAwaitReviewList] = useState<Array<TicketDto>>();
  const [ticketOpenReviewList, setTicketOpenReviewList] = useState<Array<TicketDto>>();
  const [ticketClosedReviewList, setTicketClosedReviewList] = useState<Array<TicketDto>>();
  const [expanded, setExpanded] = useState<any>({ accordion1: true, accordion2: true, accordion3: false });

  const handleChange = (name: any) => (event: any, newExpanded: any) => {
    setExpanded({ ...expanded, [name]: !expanded[name] });
  };

  const [ticket, setTicket] = useState<TicketDto>();
  const {
    axiosGetTicketList,
    axiosTicketSave,
    axiosTicketDelete,
    axiosGetTicketById,
    axiosTicketResponse,
    axiosGetReviewTicketList,
  }: TicketControllerType = TicketController();

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    getTicketList();
    getTicketReviewList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTicketList = () => {
    axiosGetTicketList()
      .then((result: any) => {
        setTicketList(result.data);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const ticketSave = (values: TicketDto) => {
    axiosTicketSave(values)
      .then((response: any) => {
        setOpen(false);
        getTicketList();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const confirm = useConfirm();

  const ticketDelete = (id: number) => {
    confirm({
      title: Labels.QUESTION_CLOSE_TICKET,
      confirmationText: Labels.YES,
      cancellationText: Labels.NO,
      confirmationButtonProps: {
        variant: "contained",
        color: "primary",
      },
    })
      .then(() => {
        axiosTicketDelete(id)
          .then((response: any) => {
            getTicketList();
            getTicketReviewList();
          })
          .catch((error: any) => {
            handleErrorMessage(showMessage, error);
          });
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const getTicketByID = (id: number) => {
    axiosGetTicketById(id)
      .then((result: any) => {
        setTicket(result.data.ticketResponses);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const sendTicketResponse = (id: number, content: any) => {
    axiosTicketResponse(id, content)
      .then((result: any) => {})
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const sortArray = (array: any) => {
    return array.sort((a: any, b: any) => b.createDate - a.createDate);
  };

  const getTicketReviewList = () => {
    axiosGetReviewTicketList()
      .then((result: any) => {
        setTicketAwaitReviewList(
          sortArray(result.data.filter((x: any) => x.status === EnumTicketStatus.AWAITING_RESPONSE))
        );
        setTicketOpenReviewList(sortArray(result.data.filter((x: any) => x.status === EnumTicketStatus.OPEN)));
        setTicketClosedReviewList(sortArray(result.data.filter((x: any) => x.status === EnumTicketStatus.CLOSED)));
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const enumTicketTypeList = [
    { id: 1, typeName: Labels.BUG, typeCode: EnumTicketType.BUG },
    { id: 2, typeName: Labels.GENERAL, typeCode: EnumTicketType.GENERAL },
    { id: 3, typeName: Labels.REQUEST, typeCode: EnumTicketType.REQUEST },
  ];

  return {
    openModal,
    closeModal,
    ticketList,
    ticketSave,
    getTicketList,
    ticketDelete,
    getTicketByID,
    ticket,
    sendTicketResponse,
    getTicketReviewList,
    ticketAwaitReviewList,
    ticketOpenReviewList,
    ticketClosedReviewList,
    enumTicketTypeList,
    open,
    setOpen,
    expanded,
    handleChange,
  };
}

export type { TicketsServiceType };
